import type { BillingPlanData } from '@shared/dream-components';
import { useQuery } from '@tanstack/react-query';

import type { AdminBillingLoaderData } from '~/routes/__loaders/admin_billing';

interface Props {
  enabled: boolean;
  subscriberId: string;
}

interface ReturnProps {
  isLoading: boolean;
  data: BillingPlanData[];
  error: string | null;
  refetch: () => void;
}

const useAdminBilling = ({ enabled, subscriberId }: Props): ReturnProps => {
  const {
    data,
    isLoading,
    refetch,
    error: queryError,
  } = useQuery({
    queryKey: ['admin-billing', subscriberId],
    queryFn: async (): Promise<AdminBillingLoaderData> => {
      const response = await fetch('/admin_billing');
      if (!response.ok) {
        throw new Error('Failed to load admin billing');
      }
      return response.json();
    },
    enabled,
    staleTime: Number.POSITIVE_INFINITY,
    refetchOnWindowFocus: false,
  });

  return {
    isLoading: isLoading && enabled,
    data: data?.plans ?? [],
    error: data?.error ?? (queryError instanceof Error ? queryError.message : null),
    refetch,
  };
};

export default useAdminBilling;
